/**
 * Convert hex to rgba
 * @param {*} hex
 * @param {*} opacity
 * @returns
 */
export function hexToRgba(hex, opacity) {
    hex = hex.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r},${g},${b},${opacity / 100})`;
}

/**
 * Merge class names
 *
 * @param  {...any} args
 * @return {string}
 */
export function classNames(...args) {
    return args.filter((arg) => !!arg).join(" ");
}

/**
 * Check if the device is mobile
 *
 * @returns {boolean}
 */
export function isMobile() {
    const ua = navigator.userAgent;
    return /Android|Mobi/i.test(ua);
}
